import React from "react";
import { View, Image } from "react-native";
import { DEVICE_SIZES } from "rn-responsive-styles";
import { AppImages } from "../../../../utility/AppImages";

interface BackgroundImageProps {
  deviceSize: DEVICE_SIZES;
  styles: any;
}

const BackgroundImage: React.FC<BackgroundImageProps> = ({ deviceSize, styles }) => {
  return (
    <View
      style={[
        {
          position: "absolute",
          flex: 1,
          height: "100%",
        },
        styles.bgImageWidth,
      ]}
    >
      <Image
        source={
          deviceSize === DEVICE_SIZES.XS
            ? AppImages.icSignUpBGMobile
            : AppImages.icSignUpBGWeb
        }
        style={{
          flex: 1,
        }}
      />
    </View>
  );
};

export default BackgroundImage;
